import gdprLogo from "@/assets/gdpr.webp";

const Footer = () => {
  return (
    <footer className="py-12 px-4 md:px-8" style={{ background: 'linear-gradient(to right, rgba(107, 122, 161, 0.9) 0%, rgba(216, 124, 106, 0.9) 100%)' }}>
      <div className="max-w-5xl mx-auto flex flex-col items-center gap-6 text-center">
        {/* Legal Links */}
        <div className="flex flex-wrap justify-center gap-4 text-sm">
          <a 
            href="/terms" 
            target="_blank"
            rel="noopener noreferrer"
            className="text-white/90 hover:text-white underline transition-colors"
          >
            Användarvillkor
          </a>
          <a 
            href="/privacy" 
            target="_blank"
            rel="noopener noreferrer"
            className="text-white/90 hover:text-white underline transition-colors"
          >
            Integritetspolicy
          </a>
          <a 
            href="/databehandlingsavtal" 
            target="_blank"
            rel="noopener noreferrer"
            className="text-white/90 hover:text-white underline transition-colors"
          >
            Databehandlingsavtal
          </a>
        </div>
        
        {/* GDPR Logo */}
        <img 
          src={gdprLogo} 
          alt="GDPR Compliant" 
          width={96}
          height={88}
          className="h-16 w-auto opacity-80"
        />
        
        {/* Company Info */}
        <div className="text-white/80 text-sm space-y-1">
          <p className="font-medium text-white">Samfora AB</p>
          <p>C/O Norrsken House</p>
          <p>Stockholm - Sverige</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
